var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishedTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 23,
    viewBox: "0 0 67 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(-1113.186 -1515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    transform: "translate(1113.186 1515)",
    fill: "#f5f7f4",
    stroke: "#307349",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 23,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 66,
    height: 22,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Published",
    transform: "translate(1120.186 1530)",
    fill: "#307349",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Published")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedTag);
export default __webpack_public_path__ + "static/media/published_tag.ebe516fd5d73d28f7361a62b1a205051.svg";
export { ForwardRef as ReactComponent };